<template>
  <div class="register-cont">
    <h1>账号登录</h1>
    <div class="tab-check">
      <p :class="[istabCheck == 1 ? 'p1' : 'p2']" @click="changeTab(1)">
        密码登录
      </p>
      <p :class="[istabCheck == 2 ? 'p1' : 'p2']" @click="changeTab(2)">
        验证码登录
      </p>
    </div>

    <userLogin
      v-if="registerType == '1'"
      :referUrl="referUrl"
      :codeLogin="codeLogin"
      @setRegisterType="setRegisterType"
    />

    <phoneLogin
      v-else
      @setRegisterType="setRegisterType"
      :referUrl="referUrl"
    />
  </div>
</template>

<script>
import { zhugeTrack, getQueryString } from "@/utils/utils";
import phoneLogin from "@/components/login/phoneLogin";
import userLogin from "@/components/login/userLogin";
export default {
  name: "bindAccount",
  components: {
    phoneLogin,
    userLogin,
  },
  data() {
    return {
      codeLogin: false,
      istabCheck: 1,
      registerType: "1",
      referUrl: "", // 登录后跳转的页面 （url携带）
    };
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");

    zhugeTrack("进入_登录页",{
      '终端':'Web'
    });
  },
  methods: {
    changeTab(value) {
      this.istabCheck = value;
      this.registerType = value;
    },
    setRegisterType(type) {
      this.registerType = type;
    },
  },

  metaInfo() {
    return {
      title:  window.location.search.indexOf('match')>-1?'用户登录 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛':'用户登录 - 博学谷·黑马程序员线上品牌',
      meta: [
        {
          name: "keyWords",
          content: "登录入口,员登录系统,网址,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷官网学员登录入口，学员登录后可以在线学习，通过线上视频课的形式学习自己所报名的课程，可以选择Java、Python、云计算大数据、前端开发、UI设计、人工智能、软件测试与移动开发、PHP、电商运营等课程。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: window.location.search.indexOf('match')>-1?'/favicon.czb.ico':'/favicon.ico' }]
    };
  },
};
</script>

<style lang="scss" scoped>
.register-cont {
  width: 464px;
  height: 520px;
  background: #ffffff;

  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 48px;
  h1 {
    height: 32px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 32px;
    margin: 48px auto 24px 136px;
  }
  .tab-check {
    display: flex;
  }
  .p1 {
    height: 24px;
    border-radius: 4px 4px 0px 0px;
    margin-right: 32px;
    line-height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #165dff;
    cursor: pointer;

    &::after {
      content: "";
      width: auto;
      height: 3px;
      background: #165dff;
      border-radius: 4px 4px 0px 0px;
      display: block;
      margin-top: 7px;
    }
  }
  .p2 {
    height: 24px;

    cursor: pointer;
    border-radius: 4px 4px 0px 0px;
    margin-right: 32px;
    line-height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    color: #4e5969;
    &:hover {
      color: #165dff;
    }
  }
}

::v-deep .user-register {
  p {
    span {
      color: #4e5969 !important;
      &:hover {
        color: #165dff !important;
      }
    }
  }
  .get-code {
    color: #4e5969 !important;
    &:hover {
      color: #165dff !important;
    }
  }
}

::v-deep .login-from {
  margin-top: 33px;
  .el-form-item {
    margin-bottom: 25px;
  }
  .el-input__inner {
    width: 368px;
    height: 40px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    line-height: 40px;
    padding-left: 16px;
    box-sizing: border-box;
    border: 1px solid #e5e6eb;
    &:focus {
      border: 1px solid #165dff;
    }
  }
  .is-error {
    .el-input__inner {
      border: 1px solid #f53f3f;
    }
    .el-form-item__error {
      color: #f53f3f;
      padding-top: 0px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f53f3f;
      line-height: 20px;
    }
  }
}

::v-deep .btn {
  background: #165dff;
  &:hover {
    background: #4080ff;
  }
}
::v-deep .other-login {
  span {
    color: #165dff;
    &:hover {
      color: #4e5969 !important;
    }
  }
}
</style>
